import React from "react";

function MainHeader(props) {
  return <header className="main-header">{props.children}</header>;
}

export default MainHeader;
